import React from 'react';

import styles from './ProgressIndicator.module.scss';

interface IProgressIndicatorProps {
	stepsCount: number;
	currentStep: number;
}

/**
 *
 * @description <add description>
 *
 * @author  Rohit Niraj Singh <@rohit.singh3>
 *
 * @returns {React.ReactElement}
 */

export default function ProgressIndicator({
	stepsCount,
	currentStep,
}: IProgressIndicatorProps) {
	return (
		<div className={styles.progressBar}>
			<div
				className={styles.progressIndicator}
				style={{
					width: `${(currentStep / stepsCount) * 100}%`,
				}}
			></div>
		</div>
	);
}
